<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field v-on:keypress.enter="logIn" label="Email" name="email" v-model="user.email" prepend-icon="mdi-account" type="text"></v-text-field>
                  <v-text-field v-on:keypress.enter="logIn" id="password" label="Password" name="password" v-model="user.password" prepend-icon="mdi-lock" type="password">
                  </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-on:click="logIn" color="primary">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        user: {}
      }
    },
    methods: {
      async logIn() {
        const axiosConfig = {
          baseURL: process.env.VUE_APP_API_URL
        }
	console.log(axiosConfig.baseURL);
        const api = axios.create(axiosConfig)
        api.post('/login', this.user).then(async res => {
          await this.$store.dispatch('auth/login', res.data)
          this.$store.dispatch('reload')
          this.$router.push('/')
        }).catch(err => {
          if(err.response.status === 401){
            this.$toastr.e("Invalid user or password")
          }
        });
      },
    }
  }
</script>
